<template>
  <div>

    <div class="choice-title">请选择要推广的商品</div>

    <div class="title-box level-2 normal"> 选择付款抖音号 </div>




      <div class="filterOperate" style="display: flex;justify-content: flex-start;"> 
        <AwemeList :dataSource="dataSource" :advertiser_id="advertiser_id" action="setAdvertiserId" @getAdvertiserId="getAdvertiserId" v-if="dataSource.length > 0" />
        <a-tag color="red" v-if="order.status" style="margin-left: 15px;width: 510px;height: 32px;line-height: 32px;text-align: left;padding-left: 15px;"> 
          <a-icon type="exclamation-circle" /> 当前户到期时间为：<b style="margin-right: 10px;">[ {{order.endtime}} ]</b>   
          <span v-if="order.c>0">当前剩余时间仅剩 <b>{{order.c}}</b> 天 </span>
          <span v-else>当前已过期 <b>{{-order.c}}</b> 天 </span> 
          <b style="margin-left: 20px;color: #1890ff;cursor: pointer;"  @click="payAccount">[ 立即续费 ]</b>
        </a-tag> 
      </div>


      <div class="title-box level-2 normal" style="letter-spacing: 1px;"> 选择投放视频/图文 （支持视频/图文链接搜索,单链接点此 <a href="#" @click="searchVisible = true">搜一搜</a>， 多链接投放点此 <a href="#" @click="searchBatchVisible = true">批量搜索</a> ）</div>



    <!-- <div class="select-video" v-if="aweme_id && aweme_item_id">
      <div class="left">
        <img :src="video_cover_url" />
      </div>
      <div class="right">
        <div class="item_title"><a-tag color="#87d068"   v-if="is_image=='1'">图文</a-tag><a-tag color="#2db7f5"  v-else-if="is_image=='0'">视频</a-tag> {{ title }}</div>
        <div class="item_id">视频ID：{{ aweme_item_id }}</div>
        <div class="awemeinfo">
          抖音号：{{ aweme_name }}(ID:{{ aweme_id }})
        </div>
        <span @click="getvideolist" class="check">更换</span>
      </div>
    </div> -->

    <div  v-if="select_videolist.length>0" >
      <div class="select-video" v-for="(item, index) in select_videolist" :key="index">
        <div class="left">
          <img :src="item.video_cover_url" />
        </div>
        <div class="right">
          <div class="item_title"><a-tag color="#87d068"   v-if="item.is_image=='1'">图文</a-tag><a-tag color="#2db7f5"  v-else-if="item.is_image=='0'">视频</a-tag> {{ item.title }}</div>
          <div class="item_id">视频ID：{{ item.aweme_item_id }}  <a-icon type="copy" @click="text_copy(item.aweme_item_id)"/></div>
          <div class="awemeinfo">
            抖音号：{{ item.aweme_name }}(ID:{{ item.aweme_id }} <a-icon type="copy" @click="text_copy(item.aweme_id)"/>)
          </div>
          <span @click="del_select_videolist(index)" class="check" style="color: red;"><a-icon type="delete" /></span>
        </div>
      </div>
    </div>
    <div class="select-video" style="height: 80px;">
      <div class="empty" @click="getvideolist">
        <div><a-icon type="video-camera" /> 点击添加视频</div>
      </div>
    </div>

    <div class="choice-title">投放设置</div>

    <div class="title-box level-2 normal"> 优化目标 </div>

    <div class="external-action-wrapper">
      <div class="layer">
        <div class="row">
          <div @click="set_external_action('AD_CONVERT_TYPE_SHOPPING')"
            :class="external_action == 'AD_CONVERT_TYPE_SHOPPING' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
            <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onxiadan.png~tplv-55ejei7tpt-image.image" class="icon"
              width="16" height="16" />
            <div class="label">
              商品购买
            </div>
          </div>

          <div @click="set_external_action('AD_CONVERT_TYPE_LIVE_ROI')"
            :class="external_action == 'AD_CONVERT_TYPE_LIVE_ROI' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
            <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onxiadan.png~tplv-55ejei7tpt-image.image" class="icon"
              width="16" height="16" />
            <div class="label">
              商品支付ROI
            </div>
            <span class="newico"> New </span>
          </div>

          <div @click="set_external_action('AD_CONVERT_TYPE_QC_FOLLOW_ACTION')"
            :class="external_action == 'AD_CONVERT_TYPE_QC_FOLLOW_ACTION' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
            <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onfensi.png~tplv-55ejei7tpt-image.image" class="icon"
              width="16" height="16" />
            <div class="label">
              粉丝提升
            </div>
          </div>
          <div @click="set_external_action('AD_CONVERT_TYPE_QC_MUST_BUY')"
            :class="external_action == 'AD_CONVERT_TYPE_QC_MUST_BUY' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
            <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onpinglun.png~tplv-55ejei7tpt-image.image" class="icon"
              width="16" height="16" />
            <div class="label">
              点赞评论
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="title-box level-2 normal"> 投放时长 (500元以上的订单建议投放6小时以上) </div>
    <div class="external-action-wrapper" style="text-align: left;">
      <a-radio-group :value="delivery_time" @change="handleDeliveryTimeChange">
        <a-radio-button value="2">
          2小时
        </a-radio-button>
        <a-radio-button value="6">
          6小时
        </a-radio-button>
        <a-radio-button value="12">
          12小时
        </a-radio-button>
        <a-radio-button value="24">
          24小时
        </a-radio-button>
        <a-radio-button value="72">
          3天
        </a-radio-button>
        <a-radio-button value="120">
          5天
        </a-radio-button>
      </a-radio-group>
    </div>


    <div class="choice-title">定向人群</div>

    <div class="title-box level-2 normal"> 选择潜在用户 </div>

    <div class="external-action-wrapper" style="text-align: left;">
      <a-radio-group :value="audience_mode" @change="handleAudienceModeChange">
        <a-radio-button value="ATUO">
          系统智能投放
        </a-radio-button>
        <a-radio-button value="CUSTOM">
          自定义定向投放
        </a-radio-button>
        <!-- <a-radio-button value="FANS">
          达人相似粉丝
        </a-radio-button> -->

      </a-radio-group>

      <a-select v-if="audience_mode=='CUSTOM'" class="filterItem" show-search placeholder="选择定向模板" option-filter-prop="children"
                style="width: 200px;margin-left: 10px;" :filter-option="filterOption" @change="handleChange">
                <a-select-option v-for="(item, index) in tempList" :key="index" :value="index">
                  {{ item.title }} </a-select-option>
      </a-select>

    </div>

    <div v-if="audience_mode == 'CUSTOM'">
      <a-form>
        <div class="title-box level-2 normal"> 定向人群 </div>
        <div class="demo-form-grid">
          <div class="form-item-container horizontal" style="border-bottom: 1px solid #dfe0e2;">
            <div>
              <div class="title-box level-4 normal">限运地区</div>
              <div class="delivery-date-wrapper">
                <div class="container interval normal">

                  <a-radio-group :value="exclude_limited_region" @change="handleRegionChange">
                    <a-radio-button value="0">
                      不排除
                    </a-radio-button>
                    <a-radio-button value="1">
                      排除
                    </a-radio-button>
                  </a-radio-group>


                </div>
              </div>
            </div>
          </div>
          <div class="form-item-container horizontal" style="border-bottom: 1px solid #dfe0e2;">
            <div>
              <div class="title-box level-4 normal">性别</div>
              <div class="delivery-schedule-wrapper">
                <div class="container interval normal">

                  <a-radio-group :value="gender" @change="handleGenderChange">
                    <a-radio-button value="">
                      不限
                    </a-radio-button>
                    <a-radio-button value="GENDER_MALE">
                      男
                    </a-radio-button>
                    <a-radio-button value="GENDER_FEMALE">
                      女
                    </a-radio-button>
                  </a-radio-group>

                </div>
              </div>
            </div>
          </div>
          <div class="form-item-container horizontal" style="border-bottom: 1px solid #dfe0e2;">
            <div>
              <div class="title-box level-4 normal">年龄</div>
              <div class="delivery-schedule-wrapper">
                <div class="container interval normal">


                  <a-checkbox :checked="age.length==0" @change="onAgeAllChange">
                    不限
                  </a-checkbox>
                  <a-checkbox-group :options="AgeOptions" @change="onAgeChange" v-model="age" />

                </div>
              </div>
            </div>
          </div>


          <div class="form-item-container horizontal" style="border-bottom: 1px solid #dfe0e2;">
            <div>
              <div class="title-box level-4 normal">兴趣标签</div>
              <div class="delivery-schedule-wrapper">
                <div class="container interval normal" style="width: 600px;text-align: left;">


                  <a-checkbox :checked="interest_categories.length==0" @change="onInterestAllChange">
                    不限
                  </a-checkbox>
                  <a-checkbox-group :options="interestOptions" @change="onInterestChange" v-model="interest_categories" />

                </div>
              </div>
            </div>
          </div>



          <div class="form-item-container horizontal">
            <div>
              <div class="title-box level-4 normal">地区</div>
              <div class="delivery-schedule-wrapper">
                <div class="container interval normal" style="width: 600px;text-align: left;">



                  <Region @city-sure="CitySure" :style-set="area.area ? 'styleSet' : ''"></Region>

                  <div class="choosed_interest" v-if="area.area">
                    已选
                    <div class="area_count">{{ area.area.length }}个</div>
                    城市：
                    <template v-if="!areaType">
                      <div v-for="(item) in area.cityname.slice(0, 11)" v-bind:key="item"><span> {{ item }} </span>
                      </div>
                    </template>
                    <template v-else>
                      <div v-for="item in area.cityname" v-bind:key="item"><span> {{ item }} </span></div>
                    </template>
                    <span v-if="!areaType && area.area.length > 11">...</span>
                    <a-icon v-if="area.area.length > 11" :type="areaType ? 'caret-up' : 'caret-down'" class="areaShowAll"
                      v-on:click="areaShowAll" :style="{ fontSize: '16px' }" />
                  </div>


                </div>
              </div>
            </div>
          </div>

          <div class="form-item-container horizontal" style="border-top: 1px solid #dfe0e2;">
           
           <div>
             <div class="title-box level-4 normal">选择达人</div>
             <div class="delivery-schedule-wrapper">
               <div class="container interval normal" style="width: 600px; text-align: left;">

                 <!-- <a href="javascript:void(0)" @click="selectDrList">选择达人</a> -->

                 <!-- <a-checkbox-group :options="author_idsOptions" v-model="author_ids" /> -->
                 <AwemeFan :cur-value="curValue" @receive="receive" />

               </div>
             </div>
           </div>
         </div>
         <div class="form-item-container horizontal" style="border-top: 1px solid #dfe0e2;" v-if="curValue.aweme_fan_time_scope">
           <div>
             <div class="title-box level-4 normal">行为类型 </div>
             <div class="delivery-schedule-wrapper">
               <div class="container interval normal">


                 <a-checkbox :checked="behaviors.length == 0" @change="onbehaviorsAllChange">
                   不限
                 </a-checkbox>
                 <a-checkbox-group :options="behaviorsOptions" @change="onbehaviorsChange" v-model="behaviors" />

               </div>
             </div>
           </div>
         </div>

          <div class="form-item-container horizontal" style="border-top: 1px solid #dfe0e2;">
            <div>
              <div class="title-box level-4 normal">存为模板</div>
              <div class="delivery-schedule-wrapper">
                <div class="container interval normal" style="width: 600px;text-align: left;">


                  <a-switch checked-children="开" un-checked-children="关"  :checked="tempstatus"  @change="tempstatus = !tempstatus"/>
             
                   
                  <a-input placeholder="输入模板名称" v-model="temptitle" style="margin-left: 20px;width: 200px;"  v-if="tempstatus"/>

                  <b  v-if="tempstatus" style="color: #1890ff;cursor: pointer;margin-left: 10px;" @click="setTemp">保存模板</b>
                
                    

                </div>
              </div>
            </div>
          </div>


        </div>
      </a-form>
    </div>


    <!-- <div v-if="audience_mode == 'FANS'">
      <a-form>
        <div class="title-box level-2 normal"> 定向人群 </div>
        <div class="demo-form-grid">
          

          <div class="form-item-container horizontal" style="border-bottom: 1px solid #dfe0e2;">
            <div>
              <div class="title-box level-4 normal">限运地区</div>
              <div class="delivery-date-wrapper">
                <div class="container interval normal">

                  <a-radio-group :value="exclude_limited_region" @change="handleRegionChange">
                    <a-radio-button value="0">
                      不排除
                    </a-radio-button>
                    <a-radio-button value="1">
                      排除
                    </a-radio-button>
                  </a-radio-group>


                </div>
              </div>
            </div>
          </div>

          <div class="form-item-container horizontal" style="border-bottom: 1px solid #dfe0e2;">
            <div>
              <div class="title-box level-4 normal">定向模板</div>
              <div class="delivery-schedule-wrapper">
                <div class="container interval normal" style="width: 600px;text-align: left;">
                  <span style="color: #1890ff;cursor: pointer;">
                  保存为模板
                </span>

                </div>
              </div>
            </div>
          </div>


        </div>
      </a-form>
    </div> -->





    <div class="title-box level-2 normal" v-if="false"> 出价模式 </div>

    <div class="external-action-wrapper" v-if="false">
      <div class="layer">
        <div class="row">
          <div @click="set_bid_mode('PRICING_ACTION')"
            :class="bid_mode == 'PRICING_ACTION' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
            <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onxiadan.png~tplv-55ejei7tpt-image.image" class="icon"
              width="16" height="16" />
            <div class="label">
              按优化目标出价
            </div>
          </div>
          <!-- <div @click="set_bid_mode('PRICING_PLAY')"
            :class="bid_mode == 'PRICING_PLAY' ? 'radio external-action-radio-button checked' : 'radio external-action-radio-button'">
            <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/onfensi.png~tplv-55ejei7tpt-image.image" class="icon"
              width="16" height="16" />
            <div class="label">
              按播放量出价
            </div>
          </div> -->
        </div>
      </div>
    </div>



    <div class="title-box level-2 normal"> 出价 </div>
    <div class="demo-form-grid">
      <div class="form-item-container horizontal" style="border-bottom: 1px solid #dfe0e2;" v-show="external_action != 'AD_CONVERT_TYPE_LIVE_ROI'" >
        <div>
          <div class="title-box level-4 normal">出价类型</div>
          <div class="delivery-date-wrapper">
            <div class="container interval normal">


              <a-radio-group :value="bid_type" @change="handleBipTypeChange">
                <a-radio-button value="AUTO_BID" :disabled="external_action == 'AD_CONVERT_TYPE_LIVE_ROI'">
                  自动出价
                </a-radio-button>
                <a-radio-button value="MANUAL_BID">
                  手动出价
                </a-radio-button>
              </a-radio-group>
              <a-input-number :min="0.1" :max="10000" placeholder="手动出价金额" v-model="cpa_bid" class="cpa_bid"
              v-if="bid_type == 'MANUAL_BID'&& external_action != 'AD_CONVERT_TYPE_LIVE_ROI'"/>

              <span v-if="bid_type == 'MANUAL_BID' && sugbid && external_action != 'AD_CONVERT_TYPE_LIVE_ROI'" class="sugbid">官方建议出价：{{ sugbid }} 元</span>

            </div>
          </div>
        </div>
      </div>
      <div v-if="external_action == 'AD_CONVERT_TYPE_LIVE_ROI'" class="form-item-container horizontal"
        style="border-bottom: 1px solid #dfe0e2;">
        <div>
          <div class="title-box level-4 normal">支付roi目标</div>
          <div class="delivery-date-wrapper">
            <div class="container interval normal">


              <a-input-number :min="0.01" :max="100" placeholder="支付roi目标" v-model="roi_goal" class="cpa_bid" />

              <span v-if="suggest_roi" class="sugbid">官方建议支付roi目标：{{ suggest_roi }} </span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-item-container horizontal">
        <div>
          <div class="title-box level-4 normal">投放金额</div>
          <div class="delivery-schedule-wrapper">
            <div class="container interval normal">
              <a-radio-group :value="amount" @change="handleAmountChange">
                <a-radio-button value="100">
                  100元
                </a-radio-button>
                <a-radio-button value="200">
                  200元
                </a-radio-button>
                <a-radio-button value="500">
                  500元
                </a-radio-button>
                <a-radio-button value="1000">
                  1000元
                </a-radio-button>
                <a-radio-button value="2000">
                  2000元
                </a-radio-button>
                <a-radio-button value="-1">
                  自定义
                </a-radio-button>
              </a-radio-group>
              <a-input-number :min="100" :max="5000000" placeholder="投放金额" v-model="diyamount" v-if="amount == '-1'"
                class="cpa_bid" />
            </div>
          </div>

          <div class="notice" v-if="amount == '-1'">
            温馨提示：自定义金额投放时，投放金额在100-5000000之间，且为10的倍数

          </div>

        </div>
      </div>
    </div>


    <div class="title-box level-2 normal"> 投放规则 </div>

    <div class="demo-form-grid">
      <div class="form-item-container horizontal" style="border-bottom: 1px solid #dfe0e2;">
        <div>
          <div class="title-box level-4 normal">投放时间</div>
          <div class="delivery-date-wrapper">
            <div class="container interval normal">


              <a-radio-group :value="dotype" @change="handleDotimeChange">
                <a-radio-button value="NOW">
                  立即投放
                </a-radio-button>
                <a-radio-button value="SET">
                  定时投放
                </a-radio-button>
                <a-radio-button value="LONG">
                  长期投放
                </a-radio-button>
              </a-radio-group>
              
              <b style="color: red;margin-left: 10px;" v-if="dotype=='LONG'">第二天0点开始将会为您自动生成当日的随心推计划创建任务，可随时取消</b>

            </div>
          </div>
        </div>
      </div>

      <div class="form-item-container horizontal" style="border-bottom: 1px solid #dfe0e2;" v-if="dotype == 'SET'||dotype == 'LONG'">
        <div>
          <div class="title-box level-4 normal">投放时间</div>
          <div class="delivery-date-wrapper">
            <div class="container interval normal"  v-if="dotype == 'SET'" >
              <a-date-picker class="dotime" v-model="dotime" show-time 
                placeholder="设置投放时间"  :disabledDate="disabledDate"  :disabledTime="disabledDateTime" 
                :defaultValue="defaultTime" format="YYYY-MM-DD HH:mm:ss"/>
            </div>
            <div class="container interval normal"  v-if="dotype == 'LONG'" >
              <a-range-picker style="width: 300px" :value="longtime" format="YYYY-MM-DD"  @change="handleLongChange" :disabled-date="disabledDayDate">
                <a-icon slot="suffixIcon" type="smile" />
              </a-range-picker> 
            </div>
          </div>
        </div>
      </div>
      <div class="form-item-container horizontal" style="border-bottom: 1px solid #dfe0e2;" v-if="dotype == 'LONG'">
        <div>
          <div class="title-box level-4 normal">投放时段</div>
          <div class="delivery-date-wrapper"> 
            <div class="container interval normal"  v-if="dotype == 'LONG'" >
              <span  v-for="(item,index) in day_times"  v-bind:key="index">
                <a-time-picker @change="(time,timeString)=>onDayChange(time,timeString,index)" style="width: 100px" :open.sync="item.open" :value="moment(item.time, 'HH:mm')" :default-value="moment(item.time, 'HH:mm')" format="HH:mm">
                <a-button slot="addon" size="small" type="primary" @click="item.open=false" style="width: 100%;">确定</a-button>
                </a-time-picker>
                <a-icon type="delete" style="margin-left: 10px;margin-right: 10px;color: red" @click="del_day_time(index)"/>
                
              </span>
              
              <span style="margin-left: 5px;cursor: pointer;" @click="add_day_time">追加时段</span>

            </div>
          </div>
        </div>
      </div>

      <div class="form-item-container horizontal">
        <div>
          <div class="title-box level-4 normal">投放笔数</div>
          <div class="delivery-schedule-wrapper">
            <div class="container interval normal">
              <a-input-number :min="1" :max="100" placeholder="投放笔数" v-model="times" class="times" /> 笔
            </div>
          </div>
        </div>
      </div>

      <div class="form-item-container horizontal" style="border-top: 1px solid rgb(223, 224, 226);">
        <div>
          <div class="title-box level-4 normal">分批投放</div>
          <div class="delivery-schedule-wrapper">
            <div class="container interval normal">

              <a-radio-group :value="is_batch" @change="handleBatchChange">
                <a-radio-button value="0">
                  否
                </a-radio-button>
                <a-radio-button value="1">
                  是
                </a-radio-button>
              </a-radio-group>

              <span v-if="is_batch == '1'" class="jgtf">
                每隔<a-input-number :min="1" :max="300" placeholder="分钟间隔" v-model="interval_time" class="interval_time" />
                分钟投放
                <a-input-number :min="1" :max="times" placeholder="投放笔数" v-model="tfnum" class="interval_time" /> 笔
              </span>


            </div>
          </div>
        </div>
      </div>


      <div class="form-item-container horizontal"  v-if="dotype == 'LONG'" >
        <div>
          <div class="title-box level-4 normal">投放备注</div>
          <div class="delivery-schedule-wrapper">
            <div class="container interval normal">
              <a-input placeholder="长期投放投放备注" v-model="remarks" /> 
            </div>
          </div>
        </div>
      </div>
      

    </div>


    <div class="title-box level-2 normal"> 投放设置 </div>

    <div class="demo-form-grid">
  

      <div class="form-item-container horizontal">
        <div>
          <div class="title-box level-4 normal">计划标签</div>
          <div class="delivery-schedule-wrapper">
            <div class="container interval normal">
              <a-input placeholder="给创建出的计划打标签" v-model="tags" style="width: 200px;"/> （ 选填 ）
            </div>
          </div>
        </div>
      </div>
 
      <div class="form-item-container horizontal"  style="border-top: 1px solid rgb(223, 224, 226);">
        <div>
          <div class="title-box level-4 normal">计划加白</div>
          <div class="delivery-schedule-wrapper">
            <div class="container interval normal">
              <a-switch checked-children="开" un-checked-children="关"  :checked="is_white"  @change="is_white = !is_white"/>
              （ 创建出的计划加白后将不会执行监控规则 ）
            </div>
          </div>
        </div>
      </div>

    </div>



    <div class="title-box level-2 normal"> 投放结果 </div>

    <div class="demo-form-grid">
      <div class="form-item-container horizontal" style="border-bottom: 1px solid #dfe0e2;">
        <div>
          <div class="title-box level-4 normal">投放数量</div>
          <div class="delivery-date-wrapper">
            <div class="container interval normal">
              <b style="color: red;" v-if="dotype=='LONG'">每日</b> 共计投放 <b style="color:red">{{ select_videolist.length }}</b> 个视频，每个视频投放 <b>{{ times }}</b> 笔，每笔投放 <b>{{ amount != '-1' ? amount : diyamount }}</b> 元，共计投放 <b style="color:red">{{ amount != '-1' ? times *
                amount*select_videolist.length : times * diyamount*select_videolist.length }}</b> 元
            </div>
          </div>
        </div>
      </div>

      <div class="form-item-container horizontal">
        <div>
          <div class="title-box level-4 normal">预估效果
            <a-tooltip placement="top" style="margin-left: 3px;">
              <template slot="title">
                <span
                  v-if="bid_mode == 'PRICING_ACTION'">系统会根据你设置的目标出价及投放设置实时估算预计下单量，出价高低会影响实际投放效果。出价仅作为投放的成本参考。实际播放量/转化量与视频质量有关。</span>
                <span
                  v-if="bid_mode == 'PRICING_PLAY'">自定义投放设置越精确，投放成本越高。实时预估可能因预估与实际投放时间点不同而存在偏差，实际效果与视频质量和订单设置有关。97%以上计划的实际推广效果在预估区间内。</span>
              </template>
              <a-icon type="question-circle" />
            </a-tooltip>
          </div>
          <div class="delivery-schedule-wrapper" v-if="bid_mode == 'PRICING_ACTION'">
            <div class="container interval normal" v-if="external_action == 'AD_CONVERT_TYPE_SHOPPING'">
              预估每笔视频带来 <b>{{ min_profit }} ~ {{ max_profit }}</b> 下单量,总计{{ times }}笔共带来 <b>{{ min_profit * times }} ~
                {{ max_profit * times }}</b> 下单量
            </div>
            <div class="container interval normal" v-if="external_action == 'AD_CONVERT_TYPE_QC_FOLLOW_ACTION'">
              预估每笔视频带来 <b>{{ min_profit }} ~ {{ max_profit }}</b> 粉丝数,总计{{ times }}笔共带来 <b>{{ min_profit * times }} ~
                {{ max_profit * times }}</b> 粉丝数
            </div>
            <div class="container interval normal" v-if="external_action == 'AD_CONVERT_TYPE_QC_MUST_BUY'">
              预估每笔视频带来 <b>{{ min_profit }} ~ {{ max_profit }}</b> 点赞评论数,总计{{ times }}笔共带来 <b>{{ min_profit * times }} ~
                {{ max_profit * times }}</b> 点赞评论数
            </div>
            <span>（实际推广效果与短视频质量有关）</span>
          </div>
          <div class="delivery-schedule-wrapper" v-if="bid_mode == 'PRICING_PLAY'">
            <div class="container interval normal" v-if="external_action == 'AD_CONVERT_TYPE_SHOPPING'">
              预估每笔视频带来 <b>{{ min_profit }} ~ {{ max_profit }}</b> 播放量,总计{{ times }}笔共带来 <b>{{ min_profit * times }} ~
                {{ max_profit * times }}</b> 播放量
            </div>
          </div>
        </div>
      </div>
    </div>












    <div class="create-btn">
      <a-button type="primary" block @click="createTask" size="large" :loading="spinning">
        立即投放
      </a-button>
    </div>


    <a-drawer class="authAccount" title="可投放视频列表（ 已支持批量选择视频 ）" width="1200px" placement="right" :visible="videoDrawer"
      @close="videoDrawer = false">
      <div class="searchWapper">  
        <div class="tips" @click="searchVisible = true">
            <a-alert message="没有找到被投放视频/图文？试试使用链接搜索，【点此搜一搜】" banner type="info" show-icon style="cursor: pointer;"/>
        </div> 
      </div>
      <div class="searchResult"> 
        <div class="searchLeft"> 
              <a-radio-group :value="zhtype" @change="handleZhChange" style="width: 97%;">
                <a-radio-button value="GF"  style="width: 32%;">
                  授权号
                </a-radio-button>
                <a-radio-button value="GL"  style="width: 32%;">
                  关联号
                </a-radio-button>
                <a-radio-button value="NEAR"  style="width: 36%;">
                  历史投放
                </a-radio-button> 
              </a-radio-group>
              <div style="margin-top: 10px;">
                <a-input-search :allowClear="true" placeholder="抖音昵称/抖音ID" v-model="searchKey" enter-button @search="onSearchKey" style="width: 97%;" />
              </div>
              <div class="shop-list" style="margin-top: 10px;height: 75vh;overflow: auto;"  v-if="zhtype=='GF'&&dataSource.length>0">
                <div  @click="getSon(opt)" :class="opt.aweme_id==select_Res.aweme_id?'shop-account-item selected':'shop-account-item'" v-for="opt in dataSource" :key="opt.aweme_id" :value="opt.aweme_id">
                  <div class="shop-account-avatar" style="border-radius: 50%;">
                    <img style="height: 50px;border-radius: 50%;" :src="opt.aweme_avatar||'http://api.douchuanec.com/assets/img/empty2.png'" />
                  </div>
                  <div class="shop-account-text">
                    <div class="byted-popover-wrapper">
                      <div class="ellipsis-text-component" :title="opt.aweme_name">
                        <a-badge :count="getAwemeCount(opt.aweme_id)" :number-style="{ backgroundColor: '#52c41a',fontSize:'12px',padding:'0px' }" v-if="getAwemeCount(opt.aweme_id)>0" />
                        <a-tooltip placement="top" :title="opt.aweme_name">
                          {{opt.aweme_name||'-'}}
                        </a-tooltip> 
                      </div>
                    </div>
                    <div class="shop-account-data" :title="opt.aweme_id">UID:{{opt.aweme_id}}  <a-icon type="copy" @click="text_copy(opt.aweme_id)"/></div> 
                  </div> 
                </div>  
              </div>
              <div class="shop-list" style="margin-top: 10px;height:75vh;overflow: auto;"  v-if="zhtype=='GL'&& glList.length>0">
                <div  @click="getSon(opt)" :class="opt.aweme_id==select_Res.aweme_id?'shop-account-item selected':'shop-account-item'" v-for="opt in glList" :key="opt.aweme_id" :value="opt.aweme_id">
                  <div class="shop-account-avatar" style="border-radius: 50%;">
                    <img style="height: 50px;border-radius: 50%;" :src="opt.aweme_avatar||'http://api.douchuanec.com/assets/img/empty2.png'" />
                  </div>
                  <div class="shop-account-text">
                    <div class="byted-popover-wrapper">
                      <div class="ellipsis-text-component" :title="opt.aweme_name">
                        <a-badge :count="getAwemeCount(opt.aweme_id)" :number-style="{ backgroundColor: '#52c41a',fontSize:'12px',padding:'0px' }"  v-if="getAwemeCount(opt.aweme_id)>0" />
                        <a-tooltip placement="top" :title="opt.aweme_name">
                          {{opt.aweme_name||'-'}}
                        </a-tooltip> 
                      </div>
                    </div>
                    <div class="shop-account-data" :title="opt.aweme_id">UID:{{opt.aweme_id}} <a-icon type="copy" @click="text_copy(opt.aweme_id)"/></div> 
                  </div> 
                </div>  
              </div>
              <div class="shop-list" style="margin-top: 10px;height: 75vh;overflow: auto;"  v-if="zhtype=='NEAR'&&nearList.length>0">
                <div  @click="getSon(opt)" :class="opt.aweme_id==select_Res.aweme_id?'shop-account-item selected':'shop-account-item'" v-for="opt in nearList" :key="opt.aweme_id" :value="opt.aweme_id">
                  <div class="shop-account-avatar" style="border-radius: 50%;">
                    <img style="height: 50px;border-radius: 50%;" :src="opt.aweme_avatar||'http://api.douchuanec.com/assets/img/empty2.png'" />
                  </div>
                  <div class="shop-account-text">
                    <div class="byted-popover-wrapper">
                      <div class="ellipsis-text-component" :title="opt.aweme_name">
                        
                        <a-tooltip placement="top" :title="opt.aweme_name">
                          {{opt.aweme_name||'-'}}
                        </a-tooltip> 
                      </div>
                    </div>
                    <div class="shop-account-data" :title="opt.aweme_id">UID:{{opt.aweme_id}} <a-icon type="copy" @click="text_copy(opt.aweme_id)"/></div> 

                    

                  </div> 
                </div>  
              </div> 
        </div>
        <div class="searchRight">
          <a-spin :spinning="video_spinning" tip="加载中..."> 
          <div class="material-virtual-viewport">
            <div style="width: 890px;height: calc(95vh - 130px);overflow-y: auto;">
              <div  class="material-row" v-if="data.length>0||video_spinning">
                  <div class="video-container" is-search-empty="true" auth-type="2"  v-for="(item,index) in data" :key="index">
                      <div @click="clickCall(item)" class="video-player video-player-size-normal no-select-border" >
                        <div class="video-player-poster" :style="'background-size: cover;background-image: url('+item.video_cover_url+');'"></div>
                        <!-- <div class="video-player-mask"></div> -->
                        <span class="start-btn"></span>
                        <div class="card-duration" v-if="item.is_image == 0"> {{getTime(item.duration)}}</div>
                        <div class="video-player-like">
                          <a-icon type="caret-right" class="video-player-like-icon"/>
                          <span class="video-player-like-num">{{item.view_cnt}}</span> 
                          <a-icon type="heart" class="video-player-like-icon"/>
                          <span class="video-player-like-num">{{item.like_cnt}}</span> 
                          <a-icon type="message"  class="video-player-like-icon"/>
                          <span class="video-player-like-num">{{item.comment_cnt}}</span> 
                        </div>
                        
                      </div>
                      <div class="aweme-id" v-if="item.product_info_id" @click="getDetail(item.product_info_id)" >
                        <div class="aweme-id-left">
                          <img :src="item.product_info_img">
                        </div>
                        <div class="aweme-id-right">
                          <h6>{{ item.product_info_name }}</h6>
                          <p> ID:{{ item.product_info_id }}</p>
                        </div>
                      </div>
                      <div class="byted-popover-wrapper" >
                        <div class="video-player-file-name"  @click="govideo(item)">
                          <a-tag color="#87d068" v-if="item.is_image=='1'">图文</a-tag>
                          <a-tag color="#2db7f5" v-else-if="item.is_image=='0'">视频</a-tag>
                          {{item.title}}</div>
                        <div style="font-size:13px;color:rgb(255, 85, 0);line-height: 25px;font-weight: 600;"><a-icon type="clock-circle" /> {{item.create_time}}</div>

 
                        <div style="font-size:12px;line-height: 20px;color:#666">ID:{{item.aweme_item_id}} <a-icon type="copy" @click="text_copy(item.aweme_item_id)"/></div>
                        <div style="font-size:12px;line-height: 20px;color:green;font-weight: bold" v-if="item.tfz_count>0">投放中计划：{{ item.tfz_count }}</div>
                        <div style="font-size:12px;line-height: 20px;color:#666" v-else>投放中计划：无</div>

                      </div>
                      <div  class="selected-con" v-if="getStatus(item)">
                        <img src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/eb4c48325f3c405da4a37af2b4dc8842~tplv-55ejei7tpt-image.image" alt="" class="selected-con-bg"><img data-v-73a17e34="" src="//p1-ecom.byteimg.com/tos-cn-i-55ejei7tpt/44e1bcb881e3451b9a3185d60fe53882~tplv-55ejei7tpt-image.image" alt="" class="selected-con-icon">
                      </div>
                  </div>
                  <div style="clear: both;"></div>
                  <a-divider  v-if="video_hasmore" style="padding-bottom: 60px;">
                    <span @click="loadmore"><a href="javascript:void(0)" >点此加载更多</a></span>
                  </a-divider>
                  <!-- <a-divider  v-else style="padding-bottom: 60px;">
                    <span>暂无更多视频</span>
                  </a-divider>  -->
              </div>  
              <div class="empty" v-else style="width: 890px;">
                <div style="height: 400px;padding: 200px;">
                  <a-empty />
                </div>
              </div> 
            </div>
          </div> 
          </a-spin>
        </div>

    
        








<!-- 
        <a-spin :spinning="video_spinning" tip="加载中...">
        <a-table :pagination="false" :columns="columns" :rowKey="(record) => record.aweme_item_id" :data-source="data">

          <div slot="aweme_item" slot-scope="text">
            <p>ID:{{text.aweme_item_id}}</p> 
            <p v-if="!text.is_image"><a href="javascript:void(0);" @click="getVideoTime(text)" v-if="!text.v_createtime">查发布时间</a><b v-else>{{text.v_createtime}}</b></p>
          </div>

          <a-tag color="#87d068" slot="is_image" slot-scope="text"  v-if="text=='1'">
        图文
      </a-tag>
      <a-tag color="#2db7f5"  slot="is_image" slot-scope="text"  v-else-if="text=='0'">
        视频
      </a-tag>
        
      
      <div slot="info" slot-scope="text">
        <span  style="color: green;font-weight: 700;" v-if="text.tfz_count>0">投放中 {{ text.tfz_count }} 条</span>
        <span  style="color: red;font-weight: 700;" v-else>无投放中计划</span>
      </div>


      <div slot="video" class="aweme-right" slot-scope="text" @click="govideo(text)">
        
        <img class="videoimg" :src="text.video_cover_url" v-if="text.video_cover_url" />

        <p><a-icon type="eye" /> {{ text.view_cnt }} <a-icon type="heart" /> {{ text.like_cnt }} <a-icon type="share-alt" /> {{ text.share_cnt }} <a-icon type="message" /> {{ text.comment_cnt }}</p>

      </div> 
          <a-button type="primary" slot="action" slot-scope="text" @click="clickCall(text)" :disabled="getSelectStatus(text)=='已添加'" >{{getSelectStatus(text)}}</a-button>
        </a-table>
        <a-divider  v-if="video_hasmore" style="padding-bottom: 60px;">
            <span @click="loadmore"><a href="javascript:void(0)" >点此加载更多</a></span>
          </a-divider>
        </a-spin> -->


      </div>

      <div :style="{}" class="drawerFooter">
       
     
      <a-button
        type="primary"
        @click="videoDrawer=false"
        :disabled="select_videolist.length == 0"
        :style="{ marginRight: '8px' }"
      >
        确定选择
      </a-button>
      <a-button :style="{ marginRight: '8px' }" @click="select_videolist=[]" :disabled="select_videolist.length == 0">
        清空选择
      </a-button>
      <a-button  @click="videoDrawer=false" >
        取消
      </a-button>
    </div>
    </a-drawer>


<!-- 
    <a-drawer class="authAccount" title="可投放视频列表" width="1000px" placement="right" :visible="awemeDrawer"
      @close="awemeDrawer = false">
      <div class="searchWapper">

      </div>
      <div class="searchResult">
        <a-table :columns="columns" :rowKey="(record) => record.aweme_item_id" :data-source="data">
          <img slot="video_cover_url" slot-scope="text" class="videoimg" :src="text" v-if="text" /> 
          <a-button type="primary" slot="action" slot-scope="text" @click="clickCall(text)" size="small">添加</a-button>
        </a-table>
      </div>
    </a-drawer> -->


    <a-modal v-if="searchVisible" v-model="searchVisible" title="搜索视频/图文" width="700px" okText="确定" :maskClosable="false"
      @ok="searchVideoSubmit" :zIndex="1002">
      <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" labelAlign="left">
        <a-form-item label="输入视频/图文链接">
          <a-input-search v-model="video_url" placeholder="请输入视频/图文链接" enter-button="搜索" @search="onSearch"/>
        </a-form-item>
      </a-form>

      
      <a-spin :spinning="loading" tip="加载中...">
      <div class="select-video" v-if="searchRes.title">
        <div class="left">
          <img :src="searchRes.origin_cover" />
        </div>
        <div class="right">
          <div class="item_title">视频标题：{{ searchRes.title }}</div>
          <div class="item_id">视频ID：{{ searchRes.group_id_str }}</div>
          <div class="awemeinfo">
            抖音号：{{ searchRes.nickname }}(UID:{{ searchRes.uid }})
          </div>
          <span @click="clearSearchRes"  class="span">清空结果</span>
        </div>
      </div>
      <div class="empty" v-else>
        <div><a-icon type="video-camera" /> 输入视频链接搜索后显示</div>
      </div>
      </a-spin>
      <span class="foot_tip">（ 可从抖音APP上找到对应的视频点击右下角复制链接粘贴到此处 ）</span>
    </a-modal>
    
    <a-modal v-if="searchBatchVisible" v-model="searchBatchVisible" title="批量搜索视频/图文" width="700px" okText="确定" :maskClosable="false"
      @ok="searchAllVideoSubmit" :zIndex="1002">
      <a-form :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }" labelAlign="left">
        <a-form-item label="" style="margin-bottom: 0px;">
          <a-textarea v-model="batch_video_url" @change="getBatchUrl" placeholder="输入视频/图文链接,多条视频请换行" style="width: 100%" :auto-size="{ minRows: 3, maxRows: 3 }" :allowClear="true"/>
        </a-form-item>
        <a-form-item label="" style="margin-bottom: 5px;text-align: right;">
          <a-button type="primary" style="width: 100%" @click="checkSearchAll">开始全部解析</a-button>
        </a-form-item>

      </a-form>

      
      <a-spin :spinning="loading" tip="加载中...">
      <div  v-if="batch_video_url&&batch_url_list.length>0" style="max-height: 600px;overflow-y: auto">
        <div v-for="(item,index) in batch_url_list" :key="index">
          <div style="line-height: 40px;text-align: left;position:relative">
            <b style="display:block;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;-o-text-overflow: ellipsis;width: 420px;">链接{{index+1}}：{{ item.url }}</b>
            <a v-if="item.status==-1" @click="retry(index)" style="position:absolute;left:430px;top:0px;">再次解析</a>
            <span @click="clearSearchList(index)" style="position:absolute;right:20px;color:red;cursor:pointer;top:0px">移除</span>
          </div>
          <div class="select-video" v-if="item.status==1">
            <div class="left">
              <img :src="item.origin_cover" />
            </div>
            <div class="right">
              <div class="item_title">视频标题：{{ item.title }}</div>
              <div class="item_id">视频ID：{{ item.group_id_str }}</div>
              <div class="awemeinfo">
                抖音号：{{ item.nickname }}(UID:{{ item.uid }})
              </div>
            </div>
          </div>
          <div class="select-video" style="height: 80px;" v-else-if="item.status==0">
            <div class="empty" >
              <div>
                <a-icon type="clock-circle" />
                待解析
              </div>
            </div>
          </div>
          <div class="select-video" style="height: 80px;" v-else-if="item.status==2">
            <div class="empty" style="color:green">
              <div>
                <a-icon type="clock-circle" />
                正在解析
              </div>
            </div>
          </div>
          <div class="select-video" style="height: 80px;" v-else-if="item.status==-1">
            <div class="empty">
              <div style="color:red">
                <a-icon type="close-circle" />
                解析失败请重试
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="empty" v-else>
        <div><a-icon type="video-camera" /> 输入视频链接搜索后显示</div>
      </div>
      </a-spin>
      <span class="foot_tip">（ 可从抖音APP上找到对应的视频点击右下角复制链接粘贴到此处 ）</span>
    </a-modal>



    <a-modal title="提示" :visible="resultvisible" :footer="null" width="700px"  @cancel="resultvisible = false">
      <a-result status="success" title="您的任务已创建成功!" sub-title="请前往【小店随心推】-》【任务管理】,查看任务具体执行进度。">
        <template #extra>
          <a-button key="console" type="primary" @click="resultvisible = false">
            再来一单
          </a-button>
          <a-button key="buy" @click="gotask">
            前往任务列表
          </a-button>
        </template>
      </a-result>

      <br />
      <br />
    </a-modal>
    


    
    <a-modal title="提设置投放密码" :visible="pwdVisible"  okText="设置投放密码" @ok="setPwd"  width="700px"  @cancel="pwdVisible = false">
      <div class="tips" > 
          <a-alert message='系统检测到您尚未设置投放密码，为了您的资金安全，建议您设置安全投放密码后进行投放！' banner type="info" show-icon/> 
      </div>
     
      <div style="width: 400px;margin: 0 auto;">
          <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }"> 
            <a-form-item label="手机号码：" labelAlign="left">
              <a-input v-model="mobile" :disabled="true" style="width: 300px;"/> 
            </a-form-item>
            <a-form-item label="验证码：" labelAlign="left">
              <a-input-search placeholder="请输入验证码" v-model="yzm"> 
                <a-button slot="enterButton" type="primary">
                  发送验证码
                </a-button>
              </a-input-search>
            </a-form-item>
            <a-form-item label="投放密码：" labelAlign="left">
              <a-input v-model="pwd"  style="width: 300px;"/> 
            </a-form-item>
            <a-form-item label="再次确认：" labelAlign="left">
              <a-input v-model="repwd"  style="width: 300px;"/> 
            </a-form-item>
            <a-form-item label="记住密码：" labelAlign="left">

              <label><a-checkbox  :checked="savepwd==1?true:false" @change="onSavePwdChange" >勾选后下次投放默认密码回填</a-checkbox></label>
          
            </a-form-item>
        </a-form>
      </div>
    </a-modal>

      
    <a-modal title="投放确定" :visible="tfVisible"  okText="立即投放" @ok="create"  width="700px"  @cancel="tfVisible = false">
     
      <div style="width: 400px;margin: 0 auto;">
          <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }"> 
            <a-form-item label="投放密码：" labelAlign="left">
              <a-input v-model="repwd"  style="width: 300px;"/> 
            </a-form-item>
            <a-form-item label="记住密码：" labelAlign="left">

              <label><a-checkbox  :checked="savepwd==1?true:false" @change="onSavePwdChange" >勾选后下次投放默认密码回填</a-checkbox></label>
          
            </a-form-item>
        </a-form>
      </div>
    </a-modal>




    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />



  </div>
</template>
<script>
import { qcApi, requestHttp } from '@utils/index';
import awemeList from './awemeList.vue';
import region from './region';
import { Modal } from 'ant-design-vue';
import awemeListTo from './awemeListTo.vue';
import { AwemeFan } from '@bytedance-ad/mui-vue2';
import moment from 'moment';
const columns = [
  {
    title: '视频id',
    key: 'aweme_item',
    width: 180,
    scopedSlots: { customRender: 'aweme_item' },
  },
  {
    title: '视频标题',
    dataIndex: 'title',
    key: 'title',
    width: 250
  },
  {
    title: '投放中计划',
    key: 'info',
    scopedSlots: { customRender: 'info' },
    width: 150,
  },
  {
    title: '类型',
    dataIndex: 'is_image',
    key: 'is_image',
    width: 50,
    scopedSlots: { customRender: 'is_image' },
  },
  {
    title: '视频信息', 
    key: 'video',
    width: 150,
    align: 'center',
    scopedSlots: { customRender: 'video' },
  },  
  {
    title: '操作',
    key: 'operation',
    fixed: 'right',
    width: 120,
    scopedSlots: { customRender: 'action' },
  },
];
const data = [];
const dataSource = [];
export default {
  name: 'createVideo',
  props: {
    select_video_info_new: {
      type: Array
    },
  },
  data() {
    return {
      loading:false,
      curValue: {},
      video_url: '',
      searchVisible: false,
      formState: '',
      videoDrawer: false,
      video_id: '',
      data,
      columns,
      marketing_goal: 'VIDEO_PROM_GOODS',
      external_action: 'AD_CONVERT_TYPE_SHOPPING',
      bid_mode: 'PRICING_ACTION',
      bid_type: 'AUTO_BID',
      cpa_bid: '',
      amount: '100',
      dataSource,
      delivery_time: '24',
      audience_mode: 'ATUO',
      diyamount: '',
      aweme_id: '',
      aweme_item_id: '',
      video_cover_url: '',
      title: '',
      aweme_name: '',
      dotime: '',
      dotype: 'NOW',
      times: 1,
      //定向
      gender: '',
      exclude_limited_region: '0',
      AgeAll: true,
      AgeOptions: [
        { label: "18-23岁", value: "AGE_BETWEEN_18_23" },
        { label: "24-30岁", value: "AGE_BETWEEN_24_30" },
        { label: "31-40岁", value: "AGE_BETWEEN_31_40" },
        { label: "41-50岁", value: "AGE_BETWEEN_41_50" }
      ],
      age: [],

      behaviorsAll: true,
      behaviorsOptions: [
        { label: "关注过此人", value: "FOLLOWED_USER" },
        { label: "点赞过视频", value: "LIKED_USER" },
        { label: "下单过商品", value: "GOODS_SHARE" }
      ],
      behaviors: [],

      author_idsOptions: [],
      author_ids: [],

      interestOptions: [{
        value: "1000",
        label: "金融"
      }, {
        value: "1001",
        label: "汽车"
      }, {
        value: "1002",
        label: "旅游"
      }, {
        value: "1003",
        label: "房产"
      }, {
        value: "1004",
        label: "科技"
      }, {
        value: "1005",
        label: "娱乐"
      }, {
        value: "1006",
        label: "家装"
      }, {
        value: "1007",
        label: "生活"
      }, {
        value: "1008",
        label: "游戏"
      }, {
        value: "1009",
        label: "教育"
      }, {
        value: "1010",
        label: "体育"
      }, {
        value: "1011",
        label: "美食"
      }, {
        value: "1012",
        label: "母婴"
      }, {
        value: "1013",
        label: "法律"
      }, {
        value: "1014",
        label: "服饰"
      }, {
        value: "1015",
        label: "美妆"
      }, {
        value: "1016",
        label: "商务服务"
      }],
      interest_categories: [],
      interestAll: true,
      area: { area: '' },
      areaType: false,
      nearList: [],
      advertiser_id: '',
      resultvisible: false,
      searchRes: {
        title: ''
      },
      awemeDrawer: false,
      sugbid: '',
      is_batch: '0',
      interval_time: '5',
      tfnum: '1',
      min_profit: '',
      max_profit: '', 
      video_spinning: false,
      video_hasmore:false,
      video_cursor:'',
      video_source:'api',
      suggest_roi: '',
      roi_goal: '',
      select_Res:{},
      is_image:0,
      defaultTime:'',
      order:{
        status:false,
        endtime:'',
        c:0,
      },
      spinning:false,
      tempList:[],
      tags:'',
      is_white:false,
      temptitle:'',
      tempstatus:false,
      select_videolist:[],
      open:false,
      longtime: ["",""],
      dayTime:'08:00',
      day_times:[{time:"04:00",open:false}],
      remarks:'',
      new_advertiser_id:'',
      pwdVisible:false,

      mobile:'',

      yzm:'',
      pwd:'',
      repwd:'',
      savepwd:1,

      tfVisible:false,
      searchBatchVisible:false,
      batch_video_url:'',
      batch_url_list:[],
      zhtype:'GF',

      glList:[],
      searchKey:'',


    };
  },

  components: {
    AwemeList: awemeList,
    Region: region,
    // AwemeListTo: awemeListTo,
    AwemeFan: AwemeFan,
  },

  watch: {
    external_action(a,b){
      this.getSuccessBid()
    }
  },
  async mounted() {
    console.log('接收到的')
    if(typeof(this.select_video_info_new)!='undefined'){ 
      this.select_videolist = this.select_video_info_new
    }
    await this.getAdvertiserList()
  },
  methods: { 
    moment,
    onSearchKey(){
      if(this.zhtype == 'GF'){
        this.getAdvertiserSearch()
      }else if(this.zhtype == 'GL'){
        this.getGlData()
      }else{
        this.getNearData()
      }
    },
    // 复制操作
    text_copy(context) {
      navigator.clipboard.writeText(context)
        .then(() => {
          this.$message.success('复制成功');
        })
        .catch(err => {
          this.$message.error('复制失败');
        });
    },
    getAwemeCount(aweme_id){
      let list = this.select_videolist.filter(function(item){
        return aweme_id == item.aweme_id
      })
      return list.length
    },
    handleZhChange(e){
      this.zhtype = e.target.value
      this.searchKey = ''
      if(this.zhtype == 'GF'){
        this.select_Res = this.dataSource[0]
        this.getSon(this.select_Res)
      }else if(this.zhtype == 'GL'){
        this.select_Res = this.glList[0]
        this.getSon(this.select_Res)
      }else{
        this.select_Res = this.nearList[0]
        this.getSon(this.select_Res)
      }
    },
    getStatus(item){
        let res = this.select_videolist.filter(function(it){
            return it.aweme_item_id == item.aweme_item_id
        }) 
        return res.length>0?1:0
    },
    getTime(value) {
      let secondTime = parseInt(value); // 秒
      let minuteTime = 0; // 分
      let hourTime = 0; // 时
      if (secondTime > 60) {
        //如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整，得到整数分钟
        minuteTime = parseInt(secondTime / 60);
        //获取秒数，秒数取余，得到整数秒数
        secondTime = parseInt(secondTime % 60);
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60);
          //获取小时后取余的分，获取分钟除以60取余的分
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      //若秒数是个位数，前面用0补齐
      secondTime = secondTime < 10 ? "0" + secondTime : secondTime;
      var result = "" + secondTime + "";
      if (minuteTime > 0) {
        //若分钟数是个位数，前面用0补齐
        minuteTime = minuteTime < 10 ? "0" + minuteTime : minuteTime;
        result = "" + minuteTime + ":" + result;
      } else {
        //若分钟数为0，用"00"表示
        result = "" + "00" + ":" + result;
      }

      if (hourTime > 0) {
        //若小时数是个位数，前面用0补齐
        hourTime = hourTime < 10 ? "0" + hourTime : hourTime;
        result = "" + hourTime + ":" + result;
      } else {
        //若小时数为0，用"00"表示
        // result =  result;
      }
      // console.log("result",result)
      return result;
    },
    disabledDate (current) {
      return current && current <  this.$moment().subtract(1, 'days').endOf('day')
    },
    getBatchUrl(){
      let list = this.batch_video_url.split('\n');
      let data = []
      if(list.length>0){
        for (let i = 0; i < list.length; i++) {
          data.push({
            url:list[i],
            origin_cover:'',
            title:'',
            group_id_str:'',
            nickname:'',
            uid:'',
            status:0,
          })
        }
      }
      this.batch_url_list = data
    },
    async checkSearchAll(){
      this.loading = true
      for (let i = 0; i < this.batch_url_list.length; i++) {
        this.batch_url_list[i].status = 2
        let video_url = this.batch_url_list[i].url;
        //1.从抖音复制过来的内容里提取url
        var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
        let urlexec = reg.exec(video_url)
        let url = ''
        let type = 'url'
        if (urlexec) {
          url = urlexec[0]
        }
        //2.用户直接输入视频链接
        if (/^[0-9]*$/.test(video_url.replace(' ', ''))) {
          url = video_url.replace(' ', '')
          type = 'id';
        }
        //3.用户直接输入链接
        if (video_url.indexOf("https://www.douyin.com/video/") != -1) {
          url = video_url.replace('https://www.douyin.com/video/', '');
          url = url.replace(' ', '')
          type = 'id';
        }
        //4.用户直接输入链接
        if (video_url.indexOf("https://www.douyin.com/note/") != -1) {
          url = video_url.replace('https://www.douyin.com/note/', '');
          url = url.replace(' ', '')
          type = 'image';
        }
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.SXT_SEARCH_VIDEO}`,
          method: 'POST',
          params: {
            url: url,
            type: type,
          },
        });
        this.loading = false
        if (code == 0) {
          this.batch_url_list[i].status = -1
        }else{
          if(data.title){
            this.batch_url_list[i].status = 1
            this.batch_url_list[i].title = data.title
            this.batch_url_list[i].origin_cover = data.origin_cover
            this.batch_url_list[i].group_id_str = data.group_id_str
            this.batch_url_list[i].nickname = data.nickname
            this.batch_url_list[i].uid = data.uid
          }else{
            this.batch_url_list[i].status = -1
          }
        }
      }  
    },
    async retry(i){
      this.batch_url_list[i].status = 2
      let video_url = this.batch_url_list[i].url;
      //1.从抖音复制过来的内容里提取url
      var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
      let urlexec = reg.exec(video_url)
      let url = ''
      let type = 'url'
      if (urlexec) {
        url = urlexec[0]
      }
      //2.用户直接输入视频链接
      if (/^[0-9]*$/.test(video_url.replace(' ', ''))) {
        url = video_url.replace(' ', '')
        type = 'id';
      }
      //3.用户直接输入链接
      if (video_url.indexOf("https://www.douyin.com/video/") != -1) {
        url = video_url.replace('https://www.douyin.com/video/', '');
        url = url.replace(' ', '')
        type = 'id';
      }
      //4.用户直接输入链接
      if (video_url.indexOf("https://www.douyin.com/note/") != -1) {
        url = video_url.replace('https://www.douyin.com/note/', '');
        url = url.replace(' ', '')
        type = 'image';
      }
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_SEARCH_VIDEO}`,
        method: 'POST',
        params: {
          url: url,
          type: type,
        },
      });
      if (code == 0) {
        this.batch_url_list[i].status = -1
      }else{
        if(data.title){
          this.batch_url_list[i].status = 1
          this.batch_url_list[i].title = data.title
          this.batch_url_list[i].origin_cover = data.origin_cover
          this.batch_url_list[i].group_id_str = data.group_id_str
          this.batch_url_list[i].nickname = data.titlenickname
          this.batch_url_list[i].uid = data.uid
        }else{
          this.batch_url_list[i].status = -1
        }
      }
    },
    clearSearchList(index){
      this.batch_url_list = this.batch_url_list.filter(function(item,i){
        return index != i
      })
    },
    setPwd(){
      
    },
    async checkPwd(){
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_QC_USER_VERIFICATION}`,
        method: 'POST',
        params: { 
        },
      }); 
      this.mobile = data.mobile
      if(data.verification){
        this.createTask()
      }else{
        // this.createTask()
        this.pwdVisible = true
      }

    },
    onSavePwdChange(e){
      if(e.target.checked){
        this.savepwd = 1
      }else{
        this.savepwd = 0
      }
    },
    disabledDayDate (current) {
      return current && current <  this.$moment().subtract(0, 'days').endOf('day')
    },
    del_select_videolist(it){
      this.select_videolist = this.select_videolist.filter((item,index) => {
        return index!= it;
      });
    },
    del_day_time(it){
      if(this.day_times.length == 1){
        this.$message.error('至少保留一个时间段');
        return
      }
      this.day_times= this.day_times.filter((item,index) => {
        return index!= it;
      });
      console.log('时段数组',this.day_times) 
    },
    add_day_time(){
      if(this.day_times.length > 4){
        this.$message.error('最多添加5个时间段');
        return
      }
      let time = ""
      let length = this.day_times.length + 1
      if( length*4 < 10){
        time = "0" + length*4
      }else{
        time = length*4
      }
      this.day_times.push({time:time+":00",open:false})
    },
    handleLongChange(e,value) {
      this.longtime = value;
      console.log(e,this.longtime)
    },
    onDayChange(time,timeString,index) {
      this.day_times[index].time = timeString
      // console.log(timeString) 
      console.log('时段数组',this.day_times) 
    },
    async getVideoTime(item){
      console.log(item)
      this.video_spinning = true
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_SXT_VIDEO_TIME}`,
        method: 'POST',
        params: { 
          advertiser_id:this.advertiser_id,
          id: item.aweme_item_id,   
        },
      }); 
      this.video_spinning = false
      if (code == 0) {
        this.$message.error(msg);
        return;
      } 
      item.v_createtime = data
    },
    async setTemp(){
      if(this.temptitle == ''){
        this.$message.error('请输入模板名称');
        return
      }
      if (this.audience_mode == 'CUSTOM' && this.curValue.aweme_fan_time_scope && !this.curValue.aweme_fan_accounts) {
        this.$message.error('当前选择达人相似粉丝，达人必选')
        return
      }

      //如果选了达人相似粉丝 则需要判断是否选了粉丝
      if (this.audience_mode == 'CUSTOM' && this.curValue.aweme_fan_time_scope && this.curValue.aweme_fan_accounts.length == 0) {
        this.$message.error('请勾选达人相似粉丝且数量不能超过20个')
        return
      }
      //如果选了达人相似粉丝 则需要判断是否选了粉丝
      if (this.audience_mode == 'CUSTOM' && this.curValue.aweme_fan_time_scope && this.curValue.aweme_fan_accounts.length > 20) {
        this.$message.error('请勾选达人相似粉丝且数量不能超过20个')
        return
      }

      if (this.audience_mode == 'CUSTOM'  && this.curValue.aweme_fan_time_scope && this.curValue.aweme_fan_accounts) {
        this.author_ids = this.curValue.aweme_fan_accounts
      } else {
        this.author_ids = ''
      }
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SET_SXT_TEMPLATE}`,
        method: 'POST',
        params: { 
          marketing_goal: 'VIDEO_PROM_GOODS',  
          behaviors: this.behaviors,
          author_ids: this.author_ids, 
          gender: this.gender,
          exclude_limited_region: this.exclude_limited_region,
          age: this.age,
          interest_categories: this.interest_categories,
          city: this.area.area ? this.area.area : '', 
          title: this.temptitle,
          curValue: JSON.stringify(this.curValue)
        },
      }); 
      if (code == 0) {
        this.$message.error(msg);
        return;
      } 
      this.$message.success(msg);
      this.getTemList()
    },
    async getTemList(){
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_SXT_TEMPLATE}`,
        method: 'POST',
        params: { 
          marketing_goal: 'VIDEO_PROM_GOODS',   
        },
      }); 
      if (code == 0) {
        this.$message.error(msg);
        return;
      }  
      this.tempList = data.list
    },
    // 时间禁止
    disabledDateTime (current) { 
      if(typeof(current)!='undefined'){ 
        let today = moment().date();
        if(today == current.date()){
          let minute = Number(moment().minutes())
          let hour = Number(moment().hour());
          let finalHour=0,finalMinute=0;
          if(current.hour() > hour ){
            finalMinute = 0
          }else{
            if(current.minute() >= 58){
              finalHour = hour + 1;
              finalMinute = 0; 
            }else{
              finalHour = hour;
              finalMinute = minute + 5;
            }
          }
          return {
            disabledHours: () => this.range(0, finalHour),
            disabledMinutes: () => this.range(0, finalMinute)
          }
        }else if(moment()>current){
          return {
            disabledHours: () => this.range(0, 24),
            disabledMinutes: () => this.range(0, 60),
            disabledSeconds: () => this.range(0, 60)
          }
      }
      }else{ 
        return {
          disabledHours: () => this.range(0, 24),
          disabledMinutes: () => this.range(0, 60),
          disabledSeconds: () => this.range(0, 60),
        }
      }
    },
    range (start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    }, 
    onbehaviorsAllChange() {
      this.behaviors = []
      this.behaviorsAll = true
    },
    onbehaviorsChange(Value) {
      this.behaviorsAll = Value.length === 0;
    }, 
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChange(e){
      console.log('选中模板'+e,this.tempList[e]) 
      this.age = this.tempList[e].age?this.tempList[e].age:[]
      this.exclude_limited_region = this.tempList[e].exclude_limited_region
      this.gender = this.tempList[e].gender
      this.interest_categories = this.tempList[e].interest_categories?this.tempList[e].interest_categories:[]
      this.area.area = this.tempList[e].city?this.tempList[e].city:[]
      this.area.cityname  = this.tempList[e].cityname?this.tempList[e].cityname:''
      this.area.areaStr = this.tempList[e].cityname?this.tempList[e].cityname:''
      this.behaviors = this.tempList[e].behaviors?this.tempList[e].behaviors:''
      this.author_ids = this.tempList[e].author_ids?this.tempList[e].author_ids:''
      this.curValue =  this.tempList[e].curValue?this.tempList[e].curValue:{}
    },
    async getEndtime(advertiser_id) { 
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_ALL_ADVERTISER}`,
        method: 'POST',
        params: {
          type: 'SXT',
          status: '',
          advertiser_id:advertiser_id
        },
      }); 
      if (code == 0) {
        // this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return; 
      let c = data.list[0].c
      console.log('DDDDDDDDD',data.list[0].order_list[0].end_time)
      if(data.list[0].order_list.length>0){ 
        let endtime = data.list[0].order_list[0].end_time
        if(c<15){
          this.order.status = true 
        }else{
          this.order.status = false
        }
        this.order.c = c
        this.order.endtime = endtime
      }
    },
    payAccount() {
      this.$router.replace('/sxt_account');
    }, 
    govideo(e) {
      const strUrl = 'https://www.douyin.com/video/' + e.aweme_item_id;
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.target = '_blank';
      a.href = strUrl;
      a.click();
      document.body.removeChild(a);
    },
    getDetail(id) {
      const strUrl = 'https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?id=' + id+"&origin_type=open_platform";
      let a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.target = '_blank';
      a.href = strUrl;
      a.click();
      document.body.removeChild(a);
    },
    set_bid_mode(bid_mode){
      if(this.is_image == 1 && bid_mode == 'PRICING_PLAY'){
        this.$message.error('选择图文投放只可以选择按优化目标出价');
        return;
      }
      this.bid_mode = bid_mode; 
      this.getAwemeEstimateProfit()
    },
    set_external_action(e) {
      if(this.is_image == 1 && (e == 'AD_CONVERT_TYPE_QC_FOLLOW_ACTION'||e == 'AD_CONVERT_TYPE_QC_MUST_BUY') ){
        this.$message.error('选择图文投放只可以选择商品购买或商品支付ROI选项');
        return;
      }
      this.external_action = e
      if (e != 'AD_CONVERT_TYPE_LIVE_ROI') {
        this.roi_goal = ''
        this.bid_type = 'AUTO_BID'
      } else {
        this.bid_type = 'MANUAL_BID'
        this.getSuggestRoi()
      }
      this.getAwemeEstimateProfit()
    },
    async getSuggestRoi() {
      //执行接口
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.AWEME_SUGGEST_RPI_GOAL_GET}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id ? this.advertiser_id : this.dataSource[0].advertiser_id,
          aweme_id: this.aweme_id ? this.aweme_id : this.dataSource[0].aweme_id,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.suggest_roi = data.ecp_roi_goal
    },
    handleBatchChange(e) {
      console.log(e)
      this.is_batch = e.target.value
    },
    receive(value) {
      // 不可缺少这一步
      console.log('组件返回的抖音号', value)
      this.curValue = value
    },
    selectDrList() {
      this.awemeDrawer = true
    },
    searchVideoSubmit() {
      if (this.searchRes.title != '') {
        console.log('查询成功', this.searchRes)
        this.aweme_id = this.searchRes.uid
        this.aweme_item_id = this.searchRes.group_id_str
        this.title = this.searchRes.title
        this.video_cover_url = this.searchRes.origin_cover
        this.aweme_name = this.searchRes.nickname
        this.videoDrawer = false
        this.searchVisible = false
        this.select_videolist.push({
          aweme_id:this.aweme_id,
          aweme_item_id:this.aweme_item_id,
          title:this.title,
          video_cover_url:this.video_cover_url,
          aweme_name:this.aweme_name
        })

      } else {
        console.log(this.searchRes)
        this.$message.error('请输入有效视频链接搜索后确定')
      }
    },
    searchAllVideoSubmit(){
      let list = this.batch_url_list.filter(function(item){
        return item.status == 1
      })
      if(list.length == 0){
        this.$message.error('请输入有效视频链接搜索后解析完成再确定')
        return
      }
      this.videoDrawer = false
      this.searchBatchVisible = false
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        this.select_videolist.push({
          aweme_id:list[i].uid,
          aweme_item_id:list[i].group_id_str,
          title:list[i].title,
          video_cover_url:list[i].origin_cover,
          aweme_name:list[i].nickname
        })
      }
    },
    clearSearchRes() {
      this.searchRes = { title: '' }
    },
    async onSearch() {
      this.loading = true
      console.log(this.video_url)
      //1.从抖音复制过来的内容里提取url
      var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
      let urlexec = reg.exec(this.video_url)
      let url = ''
      let type = 'url'
      if (urlexec) {
        url = urlexec[0]
      }
      //2.用户直接输入视频链接
      if (/^[0-9]*$/.test(this.video_url.replace(' ', ''))) {
        url = this.video_url.replace(' ', '')
        type = 'id';
      }
      //3.用户直接输入链接
      if (this.video_url.indexOf("https://www.douyin.com/video/") != -1) {
        url = this.video_url.replace('https://www.douyin.com/video/', '');
        url = url.replace(' ', '')
        type = 'id';
      }
      //4.用户直接输入链接
      if (this.video_url.indexOf("https://www.douyin.com/note/") != -1) {
        url = this.video_url.replace('https://www.douyin.com/note/', '');
        url = url.replace(' ', '')
        type = 'image';
      }
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_SEARCH_VIDEO}`,
        method: 'POST',
        params: {
          url: url,
          type: type,
        },
      });
      this.loading = false
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.searchRes = data
      console.log(data)

    },
    gotask() {
      this.$router.replace('/sxt_planManage');
    },
    onAgeAllChange() {
      this.age = []
      this.AgeAll = true
    },
    onAgeChange(Value) {
      this.AgeAll = Value.length === 0;
    },
    areaShowAll() {
      this.areaType = this.areaType ? false : true
    },
    onInterestAllChange() {
      this.interest_categories = []
      this.interestAll = true
    },
    onInterestChange(Value) {
      this.interestAll = Value.length === 0;
    },
    async getGlData() {
      const { code, msg, data } = await requestHttp({
        // api: `${qcApi.SXT_AWEME_NEAR_CREATE}`,
        api: `${qcApi.SXT_AWEME_AUTHORIZED}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.glList = data.aweme_id_list
      console.log('近期投放', data.list)
    },
    async getNearData() {
      console.log(1111)
      this.nearList = []
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_AWEME_NEAR_CREATE}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          account: this.searchKey
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.nearList = data.list
      console.log('近期投放', data.list)
    },
    clickCall(e) {
      console.log('选中的', e)
      // this.aweme_id = e.aweme_id
      // this.aweme_item_id = e.aweme_item_id
      // this.title = e.title
      // this.video_cover_url = e.video_cover_url
      // this.aweme_name = e.aweme_name
      // // this.videoDrawer = false
      // this.is_image = e.is_image
      // if(e.is_image == 1){
      //   this.bid_mode = 'PRICING_ACTION'
      //   this.external_action = 'AD_CONVERT_TYPE_SHOPPING'
      // }
      // this.select_videolist.push({
      //     aweme_id:this.aweme_id,
      //     aweme_item_id:this.aweme_item_id,
      //     title:this.title,
      //     video_cover_url:this.video_cover_url,
      //     aweme_name:this.aweme_name,
      //     is_image:this.is_image
      // })
      // this.getNearData()
      if(this.getStatus(e) == 1){
        this.select_videolist  =  this.select_videolist.filter(function(it){
          return it.aweme_item_id != e.aweme_item_id
        })
      }else{
        this.select_videolist.push({
            aweme_id:e.aweme_id,
            aweme_item_id:e.aweme_item_id,
            title:e.title,
            video_cover_url:e.video_cover_url,
            aweme_name:e.aweme_name,
            is_image:e.is_image
        })
      }

    },
    getSelectStatus(text){
      let status = false
      for (let i = 0; i < this.select_videolist.length; i++) {
        if(text.aweme_item_id == this.select_videolist[i].aweme_item_id){
          status = true
        } 
      }
      if(status){ 
        return '已添加'
      }else{
        return '添加'
      }
    },
    async createTask() {
      if (this.select_videolist.length == 0) {
        this.$message.error('请选择被投放视频')
        return
      }
      if (this.bid_type == 'MANUAL_BID' && this.cpa_bid == ''&& this.external_action != 'AD_CONVERT_TYPE_LIVE_ROI') {
        this.$message.error('请输入出价')
        return
      }
      if (this.external_action == 'AD_CONVERT_TYPE_LIVE_ROI' && this.roi_goal == '') {
        this.$message.error('请输入商品支付ROI')
        return
      }
      let amount = this.amount != '-1' ? this.amount : this.diyamount
      console.log(amount)
      if (amount < 100 || amount % 10 != 0 || amount == '') {
        this.$message.error('投放金额需要大于100且为10的倍数')
        return
      }

      if (this.external_action == 'AD_CONVERT_TYPE_LIVE_ROI' && this.roi_goal == '') {
        this.$message.error('请输入支付目标roi')
        return
      }

      if (this.audience_mode == 'CUSTOM' && this.curValue.aweme_fan_time_scope && !this.curValue.aweme_fan_accounts) {
        this.$message.error('当前选择达人相似粉丝，达人必选')
        return
      }

      //如果选了达人相似粉丝 则需要判断是否选了粉丝
      if (this.audience_mode == 'CUSTOM' && this.curValue.aweme_fan_time_scope && this.curValue.aweme_fan_accounts.length == 0) {
        this.$message.error('请勾选达人相似粉丝且数量不能超过20个')
        return
      }
      //如果选了达人相似粉丝 则需要判断是否选了粉丝
      if (this.audience_mode == 'CUSTOM' && this.curValue.aweme_fan_time_scope && this.curValue.aweme_fan_accounts.length > 20) {
        this.$message.error('请勾选达人相似粉丝且数量不能超过20个')
        return
      }

      if (this.audience_mode == 'CUSTOM'  && this.curValue.aweme_fan_time_scope && this.curValue.aweme_fan_accounts) {
        this.author_ids = this.curValue.aweme_fan_accounts
      } else {
        this.author_ids = ''
      }

      let day_arr = []
      if(this.dotype == 'LONG'){
        if(this.longtime[0] == ''){
          this.$message.error('您已选择长期投放，请选择开始结束时间！')
          return
        }
        for (let index = 0; index < this.day_times.length; index++) {
          day_arr.push(this.day_times[index].time) 
        }
        this.dayTime = day_arr.join(',')
      }

      this.amount = amount

      // this.tfVisible = true
      Modal.confirm({
        title: '提醒',
        content: '是否确定创建随心推计划？',
        onOk: () => {
          this.create()
        },
      });
    },
    async create() {
      this.spinning = true
      for (let i = 0; i < this.select_videolist.length; i++) { 
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.CREATE_SXT_VIDEO_TASK_BATCH}`,
            method: 'POST',
            params: {
              advertiser_id: this.advertiser_id ? this.advertiser_id : this.dataSource[0].advertiser_id,
              marketing_goal: 'VIDEO_PROM_GOODS',
              aweme_id: this.select_videolist[i].aweme_id,
              aweme_item_id: this.select_videolist[i].aweme_item_id, 
              //20230909新增start
              title : this.select_videolist[i].title, 
              video_cover_url : this.select_videolist[i].video_cover_url, 
              aweme_name : this.select_videolist[i].aweme_name, 
              //20230909新增end
              external_action: this.external_action,
              delivery_time: this.delivery_time,
              bid_mode: this.bid_mode,
              bid_type: this.bid_type,
              cpa_bid: this.cpa_bid,
              roi_goal: this.external_action == 'AD_CONVERT_TYPE_LIVE_ROI' ? this.roi_goal : '',
              amount: this.amount,
              audience_mode: this.audience_mode,
              behaviors: this.behaviors,
              author_ids: this.author_ids,
              times: this.times,
              dotype: this.dotype,
              source: 'WEB',
              dotime: this.dotype == 'SET' ? this.dotime : '',
              gender: this.gender,
              exclude_limited_region: this.exclude_limited_region,
              age: this.age,
              interest_categories: this.interest_categories,
              city: this.area.area ? this.area.area : '',
              is_batch: this.is_batch,
              interval_time: this.interval_time,
              tfnum: this.tfnum,
              tags:this.tags,
              is_white:this.is_white?1:0,
              //20240411新增长期投放参数
              longtime_start:this.longtime[0],
              longtime_end:this.longtime[1],
              day_time:this.dayTime,
              remarks:this.remarks
            },
          });
          if (code == 0) {
            this.spinning = false
            this.$message.error(msg);
            return;
          }
      }
      this.spinning = false
      this.resultvisible = true
      // this.$success({
      //   title: msg,
      //   content: '',
      // });

    },
    getAdvertiserId(advertiser_id) {
      this.advertiser_id = advertiser_id
      this.new_advertiser_id = advertiser_id //投放号
      this.getGlData()
      this.getEndtime(advertiser_id)
      console.log('子组件传回的值', advertiser_id)
    },
    async getSon(e) {
      this.select_Res = e
      if (this.zhtype == 'NEAR') {
        this.video_spinning = true
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.SXT_OTHER_VIDEO_GET}`,
          method: 'POST',
          params: {
            aweme_id: e.aweme_id,
            marketing_goal: 'LIVE_PROM_GOODS'
          },
        });
        this.video_spinning = false
        if (code == 0) {
          this.$message.error(msg);
          return;
        }
        // debugger 
        if (!data) return;
        this.data = data.list
      } else {
        this.video_spinning = true
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.SXT_AWEME_VIDEO_GET}`,
          method: 'POST',
          params: {
            access_token: e.access_token,
            advertiser_id: e.advertiser_id,
            aweme_id: e.aweme_id,
            aweme_name: e.aweme_name,
            marketing_goal: this.marketing_goal,
            new_advertiser_id:this.new_advertiser_id
          },
        });
        this.video_spinning = false
        if (code == 0) {
          this.data = []
          this.$message.error(msg);
          return;
        }
        if (!data) return;
        console.log('回传的视频数据1111', data);
        this.data = data.video_list
        this.video_hasmore = data.page_info.has_more
        this.video_cursor = data.page_info.cursor
      }
    },
    async loadmore(){ 
      let select_Res = this.select_Res
      if (this.video_source == 'api' && this.video_hasmore) {
        this.video_spinning = true
        const { code, msg, data } = await requestHttp({
          api: `${qcApi.SXT_AWEME_VIDEO_GET}`,
          method: 'POST',
          params: {
            access_token: select_Res.access_token,
            advertiser_id: select_Res.advertiser_id,
            aweme_id: select_Res.aweme_id,
            aweme_name: select_Res.aweme_name,
            marketing_goal: this.marketing_goal,
            page:this.video_cursor,
            new_advertiser_id:this.new_advertiser_id
          },
        });
        this.video_spinning = false
        if (code == 0) {
          this.$message.error(msg);
          return;
        }
        if (!data) return;
        console.log('回传的视频数据1111', data);
        let dd = data.video_list 
        if(dd.length>0){
          for (var i = 0; i < dd.length; i++) {
            this.data.push(dd[i])
          }
        } 
        this.video_hasmore = data.page_info.has_more
        this.video_cursor = data.page_info.cursor
      }
    },
    async getAdvertiserSearch(){
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_ADVERTISER_LIST}`,
        method: 'POST',
        params: {
          type: 'SXT',
          account:this.searchKey
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      this.dataSource = data.list
    },
    async getAdvertiserList() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_ADVERTISER_LIST}`,
        method: 'POST',
        params: {
          type: 'SXT',
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      if (data.list.length == 0) {
        Modal.confirm({
          title: '提醒',
          content: '您尚未授权随心推账户，是否前往授权？',
          onOk: () => {
            this.$router.replace('/sxt_account');
          },
        });
      } else {
        // this.advertiser_id =  data.list[0].advertiser_id
        console.log('缓存的户ID',localStorage.getItem('sxt_advertiser_id'))
        if(localStorage.getItem('sxt_advertiser_id')){
          this.advertiser_id = localStorage.getItem('sxt_advertiser_id')
        }else{
          this.advertiser_id = data.list[0].advertiser_id; 
        } 
        this.new_advertiser_id = this.advertiser_id //投放号
        this.dataSource = data.list
        this.getNearData()
        this.getGlData()
        this.getAwemeEstimateProfit()
        this.getEndtime(this.advertiser_id)
      }
    },
    CitySure(e) {
      this.area = e
      console.log('选择好的城市数据', e)
    },
    handleBipTypeChange(e) {
      this.bid_type = e.target.value;
      if (this.bid_type == 'MANUAL_BID') {
        this.getSuccessBid()
      }
    },
    async getSuccessBid() {
      //执行接口
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.AWEME_SUGGEST_BID_GET}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id ? this.advertiser_id : this.dataSource[0].advertiser_id,
          external_action: this.external_action,
          amount: this.amount,
          audience_mode: this.audience_mode,
          author_ids: this.author_ids,
          times: this.times,
          dotype: this.dotype,
          source: 'WEB',
          dotime: this.dotype == 'SET' ? this.dotime : '',
          gender: this.gender,
          exclude_limited_region: this.exclude_limited_region,
          age: this.age,
          interest_categories: this.interest_categories,
          city: this.area.area ? this.area.area : '',
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.sugbid = data.suggest_bid
      this.getAwemeEstimateProfit()
    },
    async getAwemeEstimateProfit() {
      //执行接口
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.AWEME_ESTIMATE_PROFIT_GET}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id ? this.advertiser_id : this.dataSource[0].advertiser_id,
          marketing_goal: 'VIDEO_PROM_GOODS',
          external_action: this.external_action,
          delivery_time: this.delivery_time,
          bid_mode: this.bid_mode,
          bid_type: this.bid_type,
          cpa_bid: this.cpa_bid,
          amount: this.amount,
          audience_mode: this.audience_mode,
          author_ids: this.author_ids,
          gender: this.gender,
          exclude_limited_region: this.exclude_limited_region,
          age: this.age,
          interest_categories: this.interest_categories,
          city: this.area.area ? this.area.area : '',
        },
      });
      if (code == 0) {
        // this.$message.error(msg);
        return;
      }
      this.min_profit = data.min_profit
      this.max_profit = data.max_profit

    },
    handleDeliveryTimeChange(e) {
      this.delivery_time = e.target.value;
    },
    handleAudienceModeChange(e) {
      this.audience_mode = e.target.value;
      if (this.audience_mode == 'CUSTOM') {
        this.getTemList();
      }
    },
    async authorGet() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_AUTHOR_GET}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.author_idsOptions = data
      console.log('达人相似观众', data)
    },
    handleAmountChange(e) {
      this.amount = e.target.value;
      if (this.amount != '-1') {
        this.getAwemeEstimateProfit()
      }
    },
    handleDotimeChange(e) {
      this.dotype = e.target.value;
      if(this.dotype == 'SET'){ 
        let date=new Date();
        let min=date.getMinutes();
        date.setMinutes(min+5);
        this.defaultTime = moment(date,'YYYY-MM-DD HH:mm:ss')
        this.dotime = this.defaultTime
      }else{
        this.defaultTime = ''
      }
    },
    handleRegionChange(e) {
      this.exclude_limited_region = e.target.value;
    },
    handleGenderChange(e) {
      this.gender = e.target.value;
      console.log(e.target.value)
    },
    getvideolist() {
      this.getNearData()//获取近期被投放号数据
      let that = this
      let select_Res = this.dataSource.filter(function(item){
        return that.advertiser_id == item.advertiser_id
      })
      this.zhtype = 'GF'
      this.getSon(select_Res[0])
      this.videoDrawer = true
    },
    handleAgeChange() {

    },
  },
};
</script>


<style lang="less" scoped>
.choice-container {
  padding-left: 20px;
}
.external-action-radio-button .label{
  font-weight: bold;
}
.newico {
  background-color: red;
  color: #fff;
  font-size: 10px;
  display: block;
  border-radius: 3px;
  position: absolute;
  right: 1px;
  top: 1px;
  padding: 0px 5px;
  font-weight: bold;
}

.cpa_bid {
  width: 150px;
  margin-left: 20px;
}

.times {
  width: 100px;
  text-align: center;
  font-weight: bold;
}

.sugbid {
  margin-left: 20px;
  color: red;
  font-weight: bold;
}

.dotime {
  // margin-left: 20px;
  width: 262px;
}

.choice-title {
  color: #333;
  font-size: 18px;
  font-weight: 600;
  line-height: 22px;
  margin-top: 25px;
  text-align: left;
}

.styleSet {
  color: #1890ff;
  border-color: #1890ff;
}

.jgtf {
  margin-left: 10px;
}

.interval_time {
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
  width: 60px;
  text-align: center;
  font-weight: bold;
}

.foot_tip {
  display: block;
  margin-top: 20px;
}

.select-video {
  border: 1px dashed #c1c1c1;
  border-radius: 4px;
  width: 648px;
  height: 110px;
  background-color: #fff;
  cursor: pointer;
  line-height: 20px;
  font-weight: 500;
  font-size: 14px;
  color: #333;

  .left {
    float: left;
    width: 100px;

    img {
      width: 70px;
      height: 85px;
      border-radius: 3px;
      cursor: pointer;
      margin: 10px;
    }
  }

  .right {
    float: left;
    width: 540px;
    padding: 10px 0px;
    position: relative;

    .item_title {
      margin-top: 5px;
      font-size: 15px;
      font-weight: bold;
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      width: 450px;
    }

    .item_id {
      margin-top: 10px;
      text-align: left;
      font-size: 14px;
    }
    .span {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #194ce5;
    }
    .check {
      position: absolute;
      right: 10px;
      top: 10px;
      color: #194ce5;
    }
    .awemeinfo {
      font-size: 14px;
      text-align: left;
      margin-top: 10px;
    }
  }
}

.cardChosen {
  background: #fff;
  border: 1px solid #1890ff;
  border-radius: 3px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .1);
  box-sizing: border-box;
  cursor: pointer;
  // position: absolute;
  // right: 0px;
  // bottom: 2px;
  // padding: 2px 5px;
}

.card-create-choice {
  display: flex;
  flex-direction: row;
  height: 144px;
  padding: 18px 24px;
  position: relative;
  width: 272px;
}

.card-create-choice .left-part {
  margin-right: 12px;
}

.card-create-choice .right-part {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.card-create-choice .right-part .header {
  color: #333;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

.card-create-choice .right-part .content {
  color: rgba(0, 0, 0, .4);
  font-size: 12px;
  line-height: 17px;
  margin-top: 8px;
}

.cardUnchosen {
  background-color: #f2f2f2;
  border: 1px solid transparent;
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
}

.create-btn {
  margin-top: 50px;
  width: 750px;
}

.choice-container .target-choice {
  column-gap: 16px;
  display: grid;
  grid-template-columns: 272px 272px;
}

.cardUnchosen:hover {
  background-color: #edf1fd
}

.level-2 {
  margin-top: 15px;
  margin-bottom: 12px;
  line-height: 20px;
  font-weight: 600;
  font-size: 14px;
  color: #323335;
}

.ant-form-item {
  margin-bottom: 20px;
}

.title-box {
  display: flex;
  align-items: center;
}

.videoimg {
  width: 50px;
  height: 70px;
  border-radius: 3px;
  cursor: pointer;
  margin-bottom: 10px;
}

.empty {
  display: grid; 
  border-radius: 4px;
  width: 648px;
  height: 80px; 
  cursor: pointer;
  line-height: 20px;
  font-weight: 500;
  font-size: 14px;
  color: #333;
  letter-spacing: 2px;
  place-items: center;
}

.external-action-wrapper .layer {
  margin-bottom: 8px;
}

.external-action-wrapper .layer .row {
  display: flex;
  flex-wrap: wrap;
}

.external-action-wrapper .layer .row .radio {
  margin-bottom: 8px;
  margin-right: 16px;
}

.external-action-radio-button.checked {
  color: #1890ff;
  background-color: #fff;
  border: 1px solid #1890ff;
}
.drawerFooter {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: left;
  z-index: 11111;
}
.aweme-id{
  background: #e6f7ff;
  padding-left: 5px;
  padding-top: 2px;
  border-radius: 3px;
  padding-right: 5px;
  margin-top: 5px;
  cursor: pointer;
  display: inline-flex;
  &:hover{
    background: #fff;
  }
  .aweme-id-left{
    display: flex;
    img{
      width: 30px;
      height: 30px;
      border-radius: 3px;
      margin-top: 2px
    }
  }
  .aweme-id-right{
    h6{
      font-size: 12px;
      margin: 0px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 142px;
      padding-left: 5px;
    }
    p{
      font-size: 12px;
      margin: 0px;
      padding-left: 5px;
    }
  }
}
.external-action-radio-button {
  color: #323335;
  background: #f8f8f9;
  background-color: rgb(248, 248, 249);
  border-radius: 4px;
  width: 205px;
  height: 48px;
  display: flex;
  align-items: center;
  flex-direction: row;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0);
}

.external-action-radio-button .label {
  font-size: 14px;
  display: flex;
  align-items: center;
}

.external-action-radio-button .icon {
  margin-left: 16px;
  margin-right: 4px;
}

.demo-form-grid {
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  border: 1px solid #dfe0e2;
  border-radius: 8px;
  overflow: hidden;
  grid-row-gap: 1px;
  background-color: #dfe0e2;
  margin-bottom: 20px;
  width: 850px;
}

.notice {
  margin-top: 10px;
  width: 600px;
  text-align: left;
}

.demo-form-grid>div {
  background: #fff;
  padding: 12px 16px;
}

.form-item-container.horizontal>div:nth-child(1) {
  display: flex;
  align-items: baseline;
}

.choosed_interest {
  line-height: 20px;
  font-size: 14px;
  color: #999;
  padding: 5px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-transition: all .4s;
  transition: all .4s;
  overflow: hidden;
}

.choosed_interest div {
  margin-right: 4px;
}

.delivery-schedule-wrapper {
  display: flex;
}

.choosed_interest .area_count {
  color: #1890ff;
  margin-right: 0;
}

.areaShowAll:hover {
  color: #1890ff;
}

.form-item-container>div:nth-child(1) {
  flex-wrap: wrap;
}

.level-4 {
  line-height: 22px;
  font-weight: normal;
  font-size: 14px;
  width: 80px;
  color: #333;
}

.title-box {
  display: flex;
  align-items: center;
}
/deep/ .row__name{
  display: none !important;
}
.mainWapper {
  height: 100% !important;
}
.tips{
  margin-bottom: 10px
}

.material-virtual-viewport {
  overflow: auto;
  position: relative;
  margin-top:5px;
  padding-left: 20px;
  &::-webkit-scrollbar {
    display: none;
  }
}

.material-item {
  width: 180px;
  height: 270px;
  background: pink;
}

.material-row {
  // position: absolute;
  // display: flex;
  // justify-content: space-between;

  ::v-deep .video-container:not(:last-child) {
    margin-right: 26px;
  }
}
.searchResult{
  display: flex;
}
.searchRight{
  width: 900px;
  height: 100%;
  display: flex;
}
.material-row-bottom {
  position: absolute;
  width: 100%;
}
.common-loading-container {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.authTypeWapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-height: 60vh;
  overflow: auto;

  .authImg {
    width: 748px;
    height: 544px;
    margin: 0 auto;
  }

  .authBtn {
    cursor: pointer
  }
}
.video-container {
  height: 450px;
  width: 180px;
  position: relative;
  border-radius: 4px;
  float:left;
  // overflow: hidden;
  .mask {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 8;
  }

  .select-border {
    border: 1px solid #eee;
    border-radius: 5px;
  }

  .not-select-border {
    // border: 1px solid transparent;
  }

  .selected-con {
    position: absolute;
    right: 0;
    top: 0;
    width: 36px;
    height: 36px;
    &-bg {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 12;
    }

    &-icon {
      display: block;
      position: absolute;
      top: 3px;
      right: 3px;
      z-index: 13;
    }
  }
  // display: flex;
}
.video-player-size-normal {
  width: 180px;
  height: 270px;
}
.video-player {
  position: relative;
  border-radius: 4px;
}
.video-player-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background: #000;
  opacity: .3;
  cursor: pointer;
}
.video-player .start-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 32px;
  height: 40px;
  background-image: url("https://p1-ad.byteimg.com/tos-cn-i-yt5q7rszul/abbc32596f064ad8a1e35642e0bcb29c~tplv-yt5q7rszul-image.image");
  background-size: cover;
  background-repeat: no-repeat;
  opacity: .8;
  cursor: pointer;
  transform: translate(-50%, -50%);
}
.video-player .card-duration {
  position: absolute;
  top: 4px;
  left: 2px;
  padding: 0 3px;
  width: 40px;
  height: 22px;
  border-radius: 4px;
  background: #111;
  color: #fff;
  font-size: 12px;
  line-height: 22px;
  opacity: .88;
}
.video-player-like{
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 13;
  display: flex;
  align-items: center;
  padding-top: 20px;
  padding-left: 10px;
  height: 48px;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(18, 18, 18, 0) 0%, rgba(0, 0, 0, 0.5) 100%);
}
.byted-popover-wrapper {
  display: inline-block;
}
.video-player-like-icon{
  color:#fff
}
.video-player-like-num {
  margin-left: 5px;
  margin-right: 10px;
  color: #fff;
  font-size: 12px;
}
.video-player-file-name {
  display: -webkit-box;
  overflow: hidden;
  autoprefixer: off;
  -webkit-box-orient: vertical;
  margin-top: 8px;
  height: 44px;
  // color: #323335;
  text-overflow: ellipsis;
  word-break: break-all;
  font-weight: 600;
  font-size: 12px;
  line-height: 22px;
  -webkit-line-clamp: 2;
  cursor: pointer;
}
.video-player-poster {
  width: 100%;
  height: 100%;
  border-radius: 4px;
  background-position: center;
  background-size: 100% auto;
  background-repeat: no-repeat;
  cursor:pointer
}
.video-container .select-border {
  border: 1px solid #194ce5;
  border-radius: 5px;
}
.video-container .selected-con {
  position: absolute;
  right: 0;
  top: 0;
}
.video-container .selected-con-bg {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 12;
}
.video-container .selected-con-icon{
  display: block;
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 13;
}
.drawer-footer-btns{
  flex: 1;
  display: flex;
  justify-content: end;
  align-items: center;
}

.authTxt {
  margin: 0 auto;
  width: 90%;
  text-align: left;
  font-size: 12px;
  margin-bottom: 5px;
}

.rowOperate {
  // display: flex;
  align-items: center;
  justify-content: flex-start;

  .actionItem {
    margin-left: 5px;
    color: #597ef7;
    cursor: pointer;

    &:last-child {
      margin-right: 0;
    }
  }
}
.searchLeft{
  background-color: #fff;
  border-radius: 8px 0 0;
  border-right: 1px solid #e5e5e5;
  overflow-y: auto;
  transition: width 0.15s ease-in-out;
  width: 260px;
  // height: calc(100vh - 60px);
  padding-top: 5px;
}
.shop-list{
  cursor: pointer;
}
.shop-account-item {
  align-items: center;
  border-radius: 4px;
  display: flex;
  height: 80px;
  justify-content: flex-start;
  padding: 16px;
  position: relative;
  width: 240px
}
.shop-account-item.selected {
  background: #edf1fd;
  position: relative;
}
.shop-account-item.selected::before {
  background-color: #1890ff;
  border-radius: 4px;
  content: "";
  display: block;
  height: 24px;
  left: 0;
  margin-top: -12px;
  position: absolute;
  top: 50%;
  width: 4px;
}
.shop-account-text {
  margin-left: 9px;
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.ellipsis-text-component {
  width: 124px;
  font-size: 12px;
  font-weight: 600;
  color: #333333;
  cursor: pointer;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 3;
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  overflow: hidden;
  line-height: 16px;
}
.shop-account-data {
  color: #999;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
}
</style>
